export default function placeHolders (id) {
  switch (id) {
    case 'name':
      return 'What is my name?'
    case 'description':
      return 'Describe me kindly'
    case '':
      return ''
    case 'price':
      return 'What am I worth?'
    case 'image':
      return 'maginous'
    case 'available':
      return 'How many of me are there?'
    case 'dealVerbiage':
      return 'Are there any deals for me?'
    case 'lot':
      return 'What is my bulk size?'
    case 'pricePerLot':
      return 'How much for a bulk order?'
  
    default:
      return ''
  }
}